import React from 'react'

import { ArrowBack } from '@mui/icons-material'
import { IconButton } from '@mui/material'
import Rodal from 'rodal'
import 'rodal/lib/rodal.css'
import styled from 'styled-components'

import { COLORS } from 'constants/style'

type RodalProps = {
  onClose: () => void
  children: React.ReactNode
  visible?: boolean
  width?: number
  height?: number
  measure?: string
  onAnimationEnd?: () => void
  showMask?: boolean
  closeOnEsc?: boolean
  closeMaskOnClick?: boolean
  showCloseButton?: boolean
  animation?: string
  enterAnimation?: string
  leaveAnimation?: string
  duration?: number
  className?: string
  customStyles?: object
  customMaskStyles?: object
  id?: string
}

type CustomModalProps = RodalProps & {
  title?: React.ReactNode | string
  customStyles?: any
  noPaddingOnBody?: boolean
  noBodyPaddingBottom?: boolean
  onBack?: () => void
}

const CustomModal = ({
  title,
  children,
  customStyles,
  noPaddingOnBody,
  noBodyPaddingBottom,
  onBack,
  ...rest
}: CustomModalProps) => {
  return (
    <StyledRodal
      height={'auto'}
      {...rest}
      customStyles={
        customStyles || {
          bottom: 'auto',
          top: '50%',
          maxHeight: 'calc(100vh - 20px)',
          transform: 'translateY(-50%)',
        }
      }
    >
      {onBack && (
        <IconButton
          onClick={onBack}
          style={{
            color: '#243162',
            position: 'absolute',
            top: 15,
            left: 10,
            zIndex: 1000,
          }}
          size="small"
        >
          <ArrowBack sx={{ fontSize: 16, color: '#243162' }} />
        </IconButton>
      )}
      <ModalTitle>{title}</ModalTitle>
      <ModalContent
        noPaddingOnBody={!!noPaddingOnBody}
        noBodyPaddingBottom={!!noBodyPaddingBottom}
        className="custom-modal-content"
      >
        {children}
      </ModalContent>
    </StyledRodal>
  )
}

const ModalTitle = styled.h2`
  margin: 0;
  color: #404040;
  font-size: 18px;
  min-height: 30px;
  margin-bottom: 30px;
  color: ${COLORS.NAVY_BLUE};
  padding: 45px 30px 0px 30px;
  text-wrap: wrap;
  font-family: 'Poppins', sans-serif;
  font-weight: 500;
`
const ModalContent = styled.div<{
  noPaddingOnBody: boolean
  noBodyPaddingBottom: boolean
}>`
  flex: 1;
  position: relative;
  overflow: auto;
  padding: ${(props) =>
    props.noPaddingOnBody
      ? '0px'
      : props.noBodyPaddingBottom
        ? '0px 30px 0px 30px'
        : '0px 30px 30px 30px'};
`

const StyledRodal = styled(Rodal)`
  &.rodal {
    z-index: 1300;
  }

  .rodal-mask {
    z-index: 1300;
  }

  .rodal-dialog {
    z-index: 1301;
    border-radius: 12px;
    display: flex;
    flex-direction: column;
    padding: 0px;
  }

  .rodal-close {
    top: 20px;
    right: 30px;
  }
`

export default CustomModal
